export default {
  setReportRerunStatus(state, payload) {
    state.rerunReport = payload
  },
  setInstitution(state, institution) {
    state.selectedInstitution = institution
  },
  resetParams(state) {
    state.selectedInstitution = {}
    state.company = ''
    state.domain = ''
    state.productUrls = ''
    state.productKeywords = ''
    state.specialInstructions = ''
    state.rerunReport = false
    state.saveAsDefaultForUser = false
    state.saveAsDefaultForGroup = false
  },
  setCompany(state, payload) {
    state.company = payload
  },
  setDomain(state, payload) {
    state.domain = payload
  },
  setProductUrls(state, payload) {
    state.productUrls = payload
  },
  setProductKeywords(state, payload) {
    state.productKeywords = payload
  },
  setSpecialInstructions(state, payload) {
    state.specialInstructions = payload
  },
  setSaveAsDefaultForUser(state, payload) {
    state.saveAsDefaultForUser = payload
  },
  setSaveAsDefaultForGroup(state, payload) {
    state.saveAsDefaultForGroup = payload
  }
}
